import React, {Component} from 'react'
import {Table, Checkbox, Dropdown} from 'semantic-ui-react'
import {dateInputStyle} from '../../edit-sales-order/date-inputs.js'
import {dateLabel} from './date-label.js'
import ExFactoryDateLogs from './ex-factory-date-logs'
import {infoCircle} from '../../cads/status-info-circle'
import {ADD_DAYS_TO_EX_FACTORY_DATE} from '../../../modules/constants'
import {Auth0Context} from '../../../contexts/auth-context'
import {colorOptions_org7, brandOptions_org7} from '../../generate-style-number/options'

class DateColumn extends Component
{

  static contextType = Auth0Context

  constructor(props)
  {
    super(props)
    this.state = {}
  }

  render() {
    let {
      exFactoryDate, overrideOriginalExfactory, cancelDate, delivDate, onChangeExFactoryDate, onChangeOverrideOriginalExfactory, onChangeCancelDate, onChangeDelivDate,
      cadId, isEditPage, brand, color, fieldOnChange
    } = this.props

    return (
      <Table.Cell>
      {dateLabel('Ex-Factory Date')}
      <input type="date"
        value={exFactoryDate}
        onChange={onChangeExFactoryDate}
        style={dateInputStyle}
      />

        {
          isEditPage
          ?
          <React.Fragment>
            <div style={{fontSize: '10px', border: '1px solid rgb(238,238,238)', marginTop: '5px', marginBottom: '5px', paddingTop: '5px', paddingLeft: '5px'}}>
              <label style={{cursor: 'pointer'}}>
                <input type="checkbox" style={{position: 'relative', top: '2px', cursor: 'pointer'}}
                  onChange={onChangeOverrideOriginalExfactory} checked={overrideOriginalExfactory === true}
                />&nbsp;
                Override Original Ex-Factory
              </label>
            </div>

            <ExFactoryDateLogs cadId={cadId}/>
          </React.Fragment>
          :
          null
        }

        {dateLabel('Cancel Date', {marginTop: '5px'})}

        <input type="date"
          value={cancelDate}
          onChange={onChangeCancelDate}
          style={dateInputStyle}
        />

        <div/>

        {dateLabel('Deliv Date', {marginTop: '5px'})}

        <input type="date"
          value={delivDate}
          onChange={onChangeDelivDate}
          style={dateInputStyle}
        />

        {
          (() => {
            let {customer} = this.context
            if (!(customer && customer.id == 7)) return null

            return (
              <React.Fragment>
                {dateLabel('Brand', {marginTop: '5px'})}
                <div style={{width: '150px'}}>
                  <Dropdown placeholder='Brand' fluid selection search
                    options={brandOptions_org7}
                    onChange={fieldOnChange}
                    name='brand'
                    value={brand && brand[cadId] != null ? brand[cadId] : null}
                  />
                </div>
                {dateLabel('Color', {marginTop: '5px'})}
                <div style={{width: '150px'}}>
                  <Dropdown placeholder='Color' fluid selection search multiple
                    options={colorOptions_org7}
                    onChange={fieldOnChange}
                    name='color'
                    value={color && color[cadId] != null ? color[cadId] : []}
                  />
                </div>
              </React.Fragment>
            )
          })()
        }

      </Table.Cell>
    )
  }
}

export default DateColumn
